export const MODAL_CONTAINER_Z_INDEX = 500;
export const MODAL_VEIL_Z_INDEX = 501;
export const MODAL_Z_INDEX = 502;
export const MODAL_TRANSITION_DURATION = 500;
